import { useIncompleteProfileToast } from './useIncompleteProfileToast'

export const IncompleteProfileToastListener = () => {
    useIncompleteProfileToast()

    return null
}
